import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { Validators, FormControl } from "@angular/forms";
import { Category } from '../../../../POS/models/category';
import * as CryptoJS from 'crypto-js';
import { ItemServiceService } from 'src/app/POS/POSServices/Setup/item-service.service';
@Component({
  selector: 'app-item-category-list',
  templateUrl: './item-category-list.component.html',
  styleUrls: ['./item-category-list.component.scss']
})
export class ItemCategoryListComponent implements OnInit {
  isreportsbtnActive: boolean = false;
  isStartDateGreaterthenEndDate: boolean = false;
  Dfiltering:boolean = true;
  Rfromdate: boolean = false;
  isCustomDateSelected: boolean = false;
  TaxRate= new FormControl("", [Validators.required]);
  fromdate = new FormControl("", [Validators.required]);
  todate = new FormControl("", [Validators.required]);
  Fromdate1: any;
  todate1: any;
  daterange = new FormControl("", [Validators.required]);
  CategoryName = new FormControl("", [Validators.required]);
  TaxType = new FormControl("", [Validators.required]);
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "2" },
    { text: "current week", value: "4" },
    { text: "Last Week", value: "1" },
    { text: "This Month", value: "1" },
    { text: "Last Month", value: "2" },
    { text: "Custom Date Range", value: "4" }
  ];
  filtering:boolean=false;
  posid:any;
  listofItemCategory:any;
  editing = {};
  rows = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;

  rowsSel = [];
  selected = [];

  constructor( private commonfunction: CommonFunctionService,private service: ItemServiceService,) {
    this.GetitemcategoryList((data) => {
      // cache our list
     
  
  });
   }
   GetitemcategoryList(cb) {
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    const req = new XMLHttpRequest();
     this.listofItemCategory=localStorage.getItem('Getitemcategorylist')
     
    if(this.listofItemCategory ==null)
    {
      this.service.GetItemCategoryList(merchantdata.PosSubscriptionId).subscribe(data => {   
      if(data !=null)

      {
        this.temp = _clone(data);
        this.rows = _clone(data);;
        this.rowsFilter = _clone(data);;
        this.rowsExp = _clone(data);
        this.rowsSort = _clone(data);
        this.rowsSel = _clone(data);
        var  employeelist = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(this.rows), 'Secret Passphrase').toString());
        localStorage.setItem("Getitemcategorylist",employeelist);
    
      }
    });
    // req.open('GET',environment.GetItemCategoryList+"?posSubscriptionId="+merchantdata.PosSubscriptionId);
    // req.onload = () => {
    //     cb(JSON.parse(req.response));
    //     var encrypted = CryptoJS.AES.encrypt(req.response, "Secret Passphrase", {
    //     });
    //      localStorage.setItem("Getitemcategorylist",encrypted);
    // };
  
  
    // req.send();
  }



  else
  {
    let  decrypteddata = localStorage.getItem('Getitemcategorylist');
    var deData= CryptoJS.AES.decrypt(decodeURIComponent(decrypteddata), 'Secret Passphrase'); 
    let data=deData.toString(CryptoJS.enc.Utf8);
if(data =="")
{
  localStorage.removeItem('Getitemcategorylist');
  window.location.reload();
}
else
{
  this.rows=JSON.parse(data);
  if(this.rows.length !=0)
  {
    if(this.rows[0].posSubscriptionId==merchantdata.PosSubscriptionId)
    {
    this.rows=JSON.parse(data);
    }
    else{
    this.rows=[];
    localStorage.removeItem('Getitemcategorylist');
     window.location.reload();
    }
  }
  else
  {
    localStorage.removeItem('Getitemcategorylist');
    window.location.reload();
  }
}


  }
}

  ngOnInit() {
  }

  
clearcache()
{
  localStorage.removeItem('Getitemcategorylist');
  window.location.reload();
}
filters()
{
  this.filtering = !this.filtering;
}
search() {
  this.GetCategoryFilrterData((data) => {
  });
}

GetCategoryFilrterData(cb) {
  var daterange = this.daterange.value;
  var categoryname = this.CategoryName.value;
  var taxtype = this.TaxType.value;
 
  if (daterange == "Today") {

    this.Fromdate1 = new Date().toISOString().slice(0, 10);
    this.todate1 = new Date().toISOString().slice(0, 10);


  }
  else if (daterange == "Yesterday") {
    const today = new Date();
    const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
    this.Fromdate1 = tomorrow;
    this.todate1 = tomorrow;

  }
  else if (daterange == "current week") {
    const today = new Date();
    const tomorrow = new Date(today.setDate(today.getDay()));


    var current = new Date();
    var weekstart = current.getDate() - current.getDay() + 1;
    var weekend = weekstart + 6;
    this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
    this.todate1 = new Date().toISOString().slice(0, 10);

  }
  else if (daterange == "Last Week") {
    var curr = new Date;
    var first = curr.getDate() - curr.getDay() - 6;
    var last = first + 6;
    this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
    this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);


  }
  else if (daterange == "This Month") {
    const today = new Date();
    // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
    //this.Fromdate1=thismonth;   
    this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
    this.todate1 = new Date().toISOString().slice(0, 10);

  }
  else if (daterange == "Last Month") {
    // var date = new Date();                
    // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
    // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
    var date = new Date();
    this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
    this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();


  }
  else if (daterange == "Custom Date Range") {

    this.Fromdate1 = this.fromdate.value;
    this.todate1 = this.todate.value;
  }
  else {
    this.Fromdate1 = '01/01/1990';
    this.todate1 ='01/01/1990';
  }
  let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
  const req = new XMLHttpRequest();
  this.service.GetItemCategoryFilterList(merchantdata.PosSubscriptionId,this.Fromdate1,this.todate1,categoryname,taxtype).subscribe(data => {   
  if(data !=null)
  {
    this.temp = _clone(data);
    this.rows = _clone(data);;
  }
});
}


selectedaterange() {
  var daterange = this.daterange.value;
  if (daterange == "Custom Date Range") {
    this.isCustomDateSelected = true;
    this.isStartDateGreaterthenEndDate = false;
    this.Rfromdate = true;
    this.Dfiltering = false;
  }
  else {
    this.isCustomDateSelected = false;
    this.isStartDateGreaterthenEndDate = false;
    this.Rfromdate = false;
   // this.search();

  }
}
checkDateRange() {
  if (this.fromdate.value != "" && this.todate.value != "") {
      if (this.fromdate.value > this.todate.value) {
          this.isreportsbtnActive = false;
          this.isStartDateGreaterthenEndDate = true;
      }
      else {
          this.isreportsbtnActive = true;
          this.isStartDateGreaterthenEndDate = false;
      }
  }
  else {
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
  }
}
resetForm(){
  this.CategoryName.reset('');
  this.TaxType.reset('');
  this.daterange.reset('');
  this.fromdate.reset('');
  this.todate.reset('');
  this.rows=[];
  }
}
